// src/modules/app-views/omnichannel/pages/Init/modals/EscalateModal/index.jsx
// *******************************************************************************
// ESCALATE MODAL
// *******************************************************************************

// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { useMemo } from 'react';
import { RiseOutlined } from '@ant-design/icons';
import GenericModal from 'components/core/GenericModal';
import appService from 'services/appService';
import omnichannelService from '../../../../service';
import escalateStep from './Step1';

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
const EscalateModal = ({ show, setShow, afterClose, conversationId, onSuccess }) => {
  // ---------------------------------------------------------------------------
  // HANDLERS
  // ---------------------------------------------------------------------------
  const handleFinish = async ({ form }) => {
    try {
      const values = form.getFieldsValue(true);
      const { entityType } = values;

      await omnichannelService.escalateContext(conversationId, {
        entityType,
        entityId: null,
      });

      appService.message({ flag: 's', text: 'context_escalated' });
      onSuccess?.();
    } catch {
      return false;
    }
  };

  // ---------------------------------------------------------------------------
  // MEMOS
  // ---------------------------------------------------------------------------
  const steps = useMemo(() => [escalateStep()], []);

  // ---------------------------------------------------------------------------
  // UI
  // ---------------------------------------------------------------------------
  return (
    <GenericModal
      show={show}
      setShow={setShow}
      icon={<RiseOutlined />}
      title="escalate_service"
      steps={steps}
      onFinish={handleFinish}
      afterClose={afterClose}
      width={480}
    />
  );
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default EscalateModal;
